export default {
  css: `
  @media print {
  @page { margin: 0; }
   html, body {
      border: 1px solid white;
      height: 99%;
      page-break-after: avoid;
      page-break-before: avoid;
       margin: 1.6cm;
   }
   .image.center-content,
   .column.center-content{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .column.center-content.title{
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .sign-holder.is-12{
    position: fixed;
    bottom:0;
    margin: 0 auto;
    margin-bottom: 25px;
  }
  .customer-holder{
    margin-top:25px
  }
  .customer-holder:first-child{
    margin-top:0
  }
  .is-print-hidden.header, .is-print-hidden.columns, .is-print-hidden.column, .is-print-hidden.footer{
    display: none !important;
    visibility: hidden !important;
  }
  #printPetDetails{
    margin: 1.6cm
  }
  #printPetDetails.break-page-before {
    page-break-before: always;
  }
}
`
};
